<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" @change="updateItem" />
    <hr />
    <h5>Ученики:</h5>
    <clients
      :clients="item.clients"
      :id="id"
      :discipline_id="item.discipline_id"
      :lessonplan_id="lessonplan_id"
      :defaultWork="defaultWork"
    />
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";
import Clients from "@/components/Item/Timetable/Info/Clients";

export default {
  data: () => ({
    cardLink: "business/timetables",
    cardSetLink: "business/timetables",
    item: null,

    fields: [],
  }),
  components: {
    Clients,
  },
  props: ["id"],
  computed: {
    lessonplan_id: {
      get() {
        return this.item.lessonplan ? this.item.lessonplan.id : null;
      },
    },
    defaultWork: {
      get() {
        return this.item &&
          this.item.lessonplan &&
          this.item.lessonplan.works &&
          this.item.lessonplan.works.length
          ? this.item.lessonplan.works[0]
          : null;
      },
    },
  },
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    this.fields.push({
      col: "col-12 col-md-6",
      label: "Выберите плановый урок",
      key: "lessonplan",
      type: "select",
      prefix: "timetable_lessonplan",
      selectKey: "title",
      modal: "lessonplan",
      params: {
        discipline_id: this.item.discipline.id,
        course_id: this.item.group.course.id,
        locale: this.item.group.locale,
      },
    });
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item) {
        this.item["lessonplan"] = item.lessonplan ? item.lessonplan : null;
      }
    },
  },
};
</script>
<style>
</style>
